// extracted by mini-css-extract-plugin
export default {"surveyToastCtn":"surveyToastNav_surveyToastCtn__ku45H","surveyToastInnerCtn":"surveyToastNav_surveyToastInnerCtn__mAhic","toastText":"surveyToastNav_toastText__Sbpa6"};